export default "__VITE_ASSET__8d23c1b2__"